<template>
  <div
    class="assessment-category-detail tw-bg-[#ffffff] tw-p-[20px] tw-flex tw-flex-col tw-justify-between tw-items-start tw-gap-[13px] tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
  >
    <div
      class="tw-w-full tw-flex tw-justify-between tw-font-Poppins tw-text-[15px] tw-font-[600] tw-text-[#211F58] tw-leading-[130%]"
    >
      <span>{{ title }}</span>
      <div
        class="tw-flex tw-items-center tw-px-[5px] tw-py-[2px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-[4px]"
      >
        <span
          class="tw-text-[11px] tw-font-[500] tw-text-[#878787] tw-leading-[130%] tw-truncate tw-max-w-[95px]"
          >{{ activeCategory?.checklistItemCategoryLabel }}</span
        >
      </div>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-[6px] tw-w-full">
      <div class="tw-flex tw-justify-between tw-w-full">
        <div
          class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
        >
          {{ getComponentUiText("app-component-assessment-title-progress-1") }}
        </div>

        <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
          {{ activeCategory?.checklistItemCategoryCompleted }}/{{
            activeCategory?.checklistItemCategoryCount
          }}
          <span class="tw-text-[#878787] tw-font-[500]">
            {{
              (
                Number(activeCategory?.checklistItemCompletedPcnt) * 100
              ).toFixed(1)
            }}%
          </span>
        </div>
      </div>

      <div class="tw-flex tw-justify-between tw-w-full">
        <div
          class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
        >
          {{
            getComponentUiText(
              "app-component-assessments-question-type-2-icon-tooltip-score-1",
            )
          }}
        </div>
        <div
          class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
        >
          <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
            {{ Math.round(+activeCategory?.checklistCategoryScore) }}/{{
              Math.round(+activeCategory?.checklistCategoryScoreMax)
            }}
            <span class="tw-text-[#878787] tw-font-[500]"
              >{{
                (activeCategory?.checklistCategoryScorePcnt * 100).toFixed(1)
              }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICategories } from "@/interfaces/assessments/ICategories";
import {
  computed,
  onMounted,
  onBeforeMount,
  onUnmounted,
  ComputedRef,
} from "vue";
import store from "@/store";
import { localStorageKey } from "@/utils/constants";
import { IChecklistMetricsCompletion } from "@/interfaces/assessments/IAssessmentDetails";
import { getComponentUiText } from "@/utils/utilities";

const props = defineProps({
  title: { type: String, required: true, default: "" },
  checklistId: { type: Number, required: true },
  progressCategories: {
    type: Array as () => ICategories[],
    default: () => [],
  },
});

const activeCategory = computed(() => {
  const activeCategory = store.state.Assessment.activeCategory;
  const category = props.progressCategories.find(
    (c) => activeCategory === c.checklistItemCategoryId,
  );
  return category as ICategories;
});

const checklistMetricsCompletion: ComputedRef<IChecklistMetricsCompletion> =
  computed(() => store.getters["Assessment/getChecklistMetricsCompletion"]);

const checklistCompletion = computed(
  () => store.state.Assessment.overviewCardData?.completionCard,
);

const percentProgress = computed(() => {
  return parseFloat(
    (checklistMetricsCompletion.value.checklistCompletionPcnt * 100).toFixed(2),
  );
});

const emit = defineEmits(["scrollToTop"]);

onBeforeMount(() => {
  const localActiveCategory = localStorage.getItem(
    localStorageKey.assessmentActiveCategory,
  );
  if (localActiveCategory) {
    store.dispatch("Assessment/changeActiveCategory", localActiveCategory);
  }
});

onMounted(() => {});

onUnmounted(() => {
  localStorage.removeItem(localStorageKey.assessmentActiveCategory);
});
</script>

<style scoped lang="scss">
.assessment-category-detail {
  height: fit-content;
  min-width: 241px;
  max-width: 241px;
}
</style>
